<template>
  <div class="hero-single-slide" :style="'background-image:url('+slide.image_path+')'">
    <div class="container">
      <div class="hero-slide-text">
        <h1>{{slide.name}}</h1>
        <p>{{slide.lead}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderItem',
  props: ['slide']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SliderItem.vue